import {NgModule} from '@angular/core';
import {SharedModule} from '@shared/shared.module';
import {CdkDragDropHelperService, TabsMenuCardModule} from '@vdw/angular-component-library';
import {AddPathLayoutTemplateComponent} from './add/add-path-layout-template.component';
import {PathLayoutTemplateOverviewPageComponent} from './overview/path-layout-template-overview-page.component';
import {pathLayoutTemplateRouting} from './path-layout-template.routing';
import {PathLayoutTemplateSettingsComponent} from './settings/path-layout-template-settings.component';

@NgModule({
  imports: [SharedModule, pathLayoutTemplateRouting, TabsMenuCardModule],
  declarations: [PathLayoutTemplateOverviewPageComponent, AddPathLayoutTemplateComponent, PathLayoutTemplateSettingsComponent],
  providers: [CdkDragDropHelperService]
})
export class PathLayoutTemplateModule {}
